import { useCallback, useEffect } from "react";
import { ShipmentHistory, CreateShipmentHistory, UpdateShipmentHistory } from "../types/models/ShipmentHistory.d";
import { UpdateEntityShipmentHistory } from "../types/models/ShipmentHistory";
import { useGetShipmentHistoryListQuery, useInsertShipmentHistoryMutation, useDeleteShipmentHistoryMutation, } from "../apis/ShipmentHistory.api";
import { useDeleteDialog, useDescriptionAlert } from '../../share';
import { useNavigate } from "react-router";
import { t } from "@lingui/core/macro";

export default function useShipmentHistory(page: number, pageSize: number) {

    const navigate = useNavigate()
    const { openDialog, closeDialog } = useDeleteDialog();

    const { openSuccessAlert, openFailAlert } = useDescriptionAlert()

    const [insertShipmentHistoryMutation, { 
        isLoading: insertShipmentHistoryLoading, 
        isSuccess: insertShipmentHistoryIsSuccess,
        isError: insertShipmentHistoryIsError,
        error: insertShipmentHistoryError,
    }] = useInsertShipmentHistoryMutation()
    
    const [deleteShipmentHistoryMutation, { 
        isLoading: deleteShipmentHistoryLoading,
        isSuccess: deleteShipmentHistoryIsSuccess,
        isError: deleteShipmentHistoryIsError,
        error: deleteShipmentHistoryError,
    }] = useDeleteShipmentHistoryMutation()

    const loading =
        insertShipmentHistoryLoading ||
        
        deleteShipmentHistoryLoading ||
        false

    const insertShipmentHistory = useCallback(async (shipmentHistory: CreateShipmentHistory, redirectPath: string|undefined) => {
        try {
            const data = await insertShipmentHistoryMutation(shipmentHistory).unwrap()
            if (data) {
                if (redirectPath) {
                    if (redirectPath !== '.') {
                        navigate(redirectPath, {relative: 'path'})
                    }
                } else {
                    navigate(`../${data.id}`, {relative: 'path'})
                }
                return data;
            }
        } catch (e) {
            console.log("add error", e)
            openFailAlert(t`Add error: ` + e.toString())
        }
    }, [insertShipmentHistoryMutation, navigate])
    
    useEffect(() => {
        if (insertShipmentHistoryIsSuccess) {
            openSuccessAlert('Shipment History created')
        } else if (insertShipmentHistoryIsError) {
            console.log("add error", insertShipmentHistoryError)
            openFailAlert(t`Shipment History add error: ` + insertShipmentHistoryError?.data?.message)
        }
    }, [
        insertShipmentHistoryIsSuccess,
        insertShipmentHistoryIsError,
        insertShipmentHistoryError
    ]);

    

    const deleteShipmentHistory = useCallback((shipmentHistory: ShipmentHistory, redirectPath: string|undefined) => {
        openDialog(async () => {
            shipmentHistory = {
                ...shipmentHistory,
            }
            try {
                const { data } = await deleteShipmentHistoryMutation(shipmentHistory);
                if (data != null) {
                    if (redirectPath) {
                        navigate(redirectPath, {relative: 'path'})
                    }
                }
            } catch (e) {
                console.log("delete error", e)
                openFailAlert(t`Delete error: ` + e.toString())
            }
            closeDialog()
        });
    }, [deleteShipmentHistoryMutation, closeDialog, openDialog])
    
    useEffect(() => {
        if (deleteShipmentHistoryIsSuccess) {
            openSuccessAlert(t`Shipment History deleted`)
        } else if (deleteShipmentHistoryIsError) {
            console.log("delete error", deleteShipmentHistoryError)
            openFailAlert(t`Shipment History delete error: ` + deleteShipmentHistoryError?.data?.message)
        }
    }, [
        deleteShipmentHistoryIsSuccess,
        deleteShipmentHistoryIsError,
        deleteShipmentHistoryError
    ]);

    return {
        loading,
        insertShipmentHistory,
        
        deleteShipmentHistory
    }
}
